import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { useId } from "react";

interface SettingSwitchProps {
  id?: string; // Made optional since we'll auto-generate
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: string;
  description?: string;
}

export const SettingSwitch = ({
  id: propId,
  checked,
  onCheckedChange,
  label,
  description,
}: SettingSwitchProps) => {
  const generatedId = useId();
  const id = propId || generatedId;

  return (
    <div className="cy:flex cy:items-start cy:justify-start cy:space-x-5">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
      <div className="cy:flex cy:flex-col">
        <Label
          htmlFor={id}
          className="cy:text-sm! cy:text-foreground!"
        >
          {label}
        </Label>
        {description && (
          <span className="cy:text-sm cy:text-muted-foreground">
            {description}
          </span>
        )}
      </div>
    </div>
  );
}; 